import { FormLabel, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Markdown } from '../../Markdown'

interface FieldLabelProps {
  label: string
  required?: boolean
}

export function FieldLabel({ label, required }: FieldLabelProps) {
  const { t } = useTranslation('@cibo/ui/Uniforms')

  return (
    <>
      <FormLabel
        component="legend"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
      >
        <Markdown>{label}</Markdown>
      </FormLabel>

      {required && <Typography variant="caption">{t('required')}</Typography>}
    </>
  )
}
